<template>
  <oie-expandable-item :open-on-init="openOnInit" data-pw="checkout-address" :heading="t('deliveryAddressHeaderLabel')">
    <template slot="pocket">
      <div v-element-loader="{ endpoint: 'auth/get' }">
        <oie-checkout-delivery-address
          v-if="addresses"
          :addresses="addresses"
          :initial-address="checkoutState.deliveryAddress"
          :v-if="customer.isCompany"
          :customer="customer"
          :open-on-init="false"></oie-checkout-delivery-address>
      </div>
    </template>

    <div class="checkout-section__content" :class="{ 'checkout-section__content--is-open': isOpen }">
      <div v-if="deliveryAddress" class="checkout-section__item checkout-address-row">
        <button class="checkout-address__edit-button" @click="editDeliveryAddressToggle()">
          <span v-if="mq('medium')" class="checkout-address__edit-button-copy">{{ t('changeAddressButtonLabel') }}</span>
          <oie-use-svg svg="pen"></oie-use-svg>
        </button>

        <div class="checkout-address-row__value">
          {{ deliveryAddress.name }}
        </div>

        <div v-if="deliveryAddress.addressCo" class="checkout-address-row__value">
          {{ deliveryAddress.addressCo }}
        </div>

        <div class="checkout-address-row__value">
          {{ deliveryAddress.addressLine1 }}
        </div>

        <div class="checkout-address-row__value">
          {{ deliveryAddress.postalCode }} {{ deliveryAddress.city }}
        </div>

        <div class="checkout-address-row__value">
          {{ deliveryAddress.countryName }}
        </div>

        <oie-checkout-address-inputs
          v-if="editDeliveryAddress && deliveryAddress"
          :address="deliveryAddress"
          css-classes="checkout-address-edit"
          @done="editDeliveryAddressToggle"></oie-checkout-address-inputs>
      </div>

      <div v-if="customer" class="checkout-section__item">
        <div class="checkout-section__header checkout-address__header">
          {{ t('invoiceAddressHeaderLabel') }}
        </div>

        <div class="checkout-address-row__value">
          {{ customer.customerName }}
        </div>

        <template v-if="customer.invoiceAddress">
          <div v-if="customer.invoiceAddress.addressCo" class="checkout-address-row__value">
            {{ customer.invoiceAddress.addressCo }}
          </div>
          <div class="checkout-address-row__value">
            {{ customer.invoiceAddress.addressLine1 }}
          </div>

          <div class="checkout-address-row__value">
            {{ customer.invoiceAddress.postalCode }} {{ customer.invoiceAddress.city }}
          </div>
          <div class="checkout-address-row__value">
            {{ customer.invoiceAddress.countryName }}
          </div>
        </template>
      </div>
    </div>

    <oie-checkout-next-step v-show="!isStepActive(componentIndex)" :component-index="componentIndex" :text="t('wizardNextStep')"></oie-checkout-next-step>
  </oie-expandable-item>
</template>

<script>
import httpService from '@/core/http-service'
import accordionMixin from '@/mixins/accordion.js'
import nextStepMixin from '@/mixins/checkout-next-step.js'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  mixins: [accordionMixin, nextStepMixin],
  props: {
    currentAddress: {
      type: Object,
      required: false,
      default: null
    },
    customer: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    editDeliveryAddress: false,
    addresses: [],
    deliveryAddress: {},
    invoiceAddress: {}
  }),
  computed: {
    ...mapGetters('checkout', ['checkoutState'])
  },
  watch: {
    customer: {
      immediate: true,
      handler(value) {
        this.isOpen = !!value
      }
    }
  },
  mounted() {
    httpService.get('auth/getShippingAddresses').then((response) => {
      this.addresses = response.data
      var address = _.find(this.addresses, (o) => { return o.id === this.checkoutState.deliveryAddressId })
      if(address !== undefined) {
        this.deliveryAddress = address
      } else {
        this.deliveryAddress = _.find(this.addresses, (o) => { return o.isPreferredAddress })
      }
      this.publish('checkout-set-address', this.deliveryAddress)
      this.publish(`checkout-wizard-step-${this.componentIndex}`, this.componentIndex)
    })

    this.subscribe('checkout-set-address', (value) => {
      this.deliveryAddress = value
    })

    this.subscribe('checkout-new-address', (value) => {
      this.addresses.push(value)
      this.publish('checkout-set-address', value)
    })
  },
  methods: {
    editDeliveryAddressToggle() {
      this.editDeliveryAddress = !this.editDeliveryAddress
    }
  }
}
</script>

<style lang="scss">
.checkout-address-select {
  margin: 0 measure(half) measure(half) measure(half);

  @include media(small) {
    margin: 0 measure(full) measure(full) measure(full);
  }
}

.checkout-address-row {
  position: relative;
  padding-top: measure(half);
  border-top: 1px solid color(border-gray);

  @include media(small) {
    padding-top: measure(full);
  }
}

.checkout-section__item .checkout-address-row__value:not(:last-child) {
  margin-bottom: measure(quarter);
}

.checkout-address__header {
  padding: 0;
}

.checkout-address__edit-button {
  @include body-smaller-semi-bold;
  position: absolute;
  top: measure(half);
  right: 0;
  display: flex;
  align-items: center;
  background-color: transparent;
  color: color(text);
  border: none;
  padding: 0;

  &:hover {
    cursor: pointer;
  }

  @include media(small) {
    top: measure(full);
  }
}

.checkout-address__edit-button > .checkout-address__edit-button-copy {
  margin-right: measure(quarter);
}

.checkout-address-edit {
  margin-top: measure(full);
  padding: 1rem;
  border: 1px solid color(border-blue-1);
  max-width: 21.25rem;
}
</style>
